import { listStudentClasses } from '$lib/api/studentActions';
import type { PageLoad } from './$types';

export const load: PageLoad = ({ fetch }) => {
  return {
    studentClasses: listStudentClasses(fetch),
    meta: {
      title: 'Classes',
      breadcrumbs: {
        activeTitle: 'Classes',
        items: [],
      },
    },
  };
};
